export enum COMMUNICATION_TYPE {
  Email = 1,
  Text = 2,
  Fax = 3,
  BP,
}
